import React from "react"
import VisibilitySensor from "react-visibility-sensor/visibility-sensor"
import md5 from "js-md5"

import ServiceCategoryIcon from "./ServiceCategoryIcon"
import ItemPrice from "../../ui-components/ItemPrice"
import {isDiscountedCartActive, getCart, useCartStateStore} from "../../stores/CartStateStore"

import style from "./index.module.sass"

function ServiceRow(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    isFixedHeight = false,
    service,
    serviceSectionPartConfigs,
    onShowModal,
  } = props

  const {
    name,
    description,
    image_url,
    service_categories,
    launch_available,
    dinner_available,
  } = service

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [cartState, dispatchCartState] = useCartStateStore()

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function Allergens({ list }) {
    if ((!isFixedHeight && list.length === 0) || !Array.isArray(list)) {
      return <div style={{ height: 9 }}></div>
    } else {
      return (
        <div className={style.allergensContainer}>
          {list.map((allergene) => {
            return (
              <ServiceCategoryIcon key={allergene.slug} slug={allergene.slug} />
            )
          })}
        </div>
      )
    }
  }

  function Tags({ lunch, dinner }) {
    let tags = []
    if (lunch && !dinner) {
      tags.push({
        color: style.greyTag,
        t: I18n.t("service_ordering.only_lunch"),
      })
    }
    if (dinner && !lunch) {
      tags.push({
        color: style.greyTag,
        t: I18n.t("service_ordering.only_dinner"),
      })
    }
    // TODO: Popular
    if (tags.length === 0) {
      return <div></div>
    } else {
      return (
        <div className={style.tagsContainer}>
          {tags.map((tag) => {
            return (
              <span key={md5(tag.t)} className={`${style.tag} ${tag.color}`}>
                {tag.t}
              </span>
            )
          })}
        </div>
      )
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let cart = getCart(cartState)
  let price_cents = service.price_cents
  let original_price_cents = service.original_price_cents

  if (isDiscountedCartActive(cart)) {
    if(!original_price_cents) {
      original_price_cents = price_cents
    }
    price_cents = price_cents * (100 - cart.promotion.percentage) / 100
  }

  // console.log("SERVICE ROW", price_cents, original_price_cents)

  // -------------------------------------

  return (
    <div
      data-test-id={`service-row-${service.id}`}
      className={`${style.serviceContainer} ${
        isFixedHeight ? style.fixedHeight : ""
      } ${props.className}`}
      onClick={() =>
        onShowModal && onShowModal(service, serviceSectionPartConfigs)
      }
    >
      <div className={style.innerLeftContainer}>
        <div
          className={`${style.name} ${isFixedHeight ? style.limit1Line : ""}`}
        >
          {name}
        </div>
        <div className={style.description}>{description}</div>
        <Allergens list={service_categories || []} />
        {!isFixedHeight && (
          <Tags lunch={launch_available} dinner={dinner_available} />
        )}
        <ItemPrice
          originalPriceCents={original_price_cents}
          priceCents={price_cents}
        />
      </div>
      {image_url && (
        <div className={style.innerRightContainer}>
          <VisibilitySensor partialVisibility={true}>
            {({ isVisible }) => (
              <div
                className={style.image}
                style={
                  isVisible ? { backgroundImage: `url(${image_url})` } : {}
                }
              />
            )}
          </VisibilitySensor>
        </div>
      )}
    </div>
  )
}

export default ServiceRow
